import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="relative pt-20 pb-32 px-4">
      <div className="container mx-auto text-center max-w-4xl">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8 border border-cyan-500/30 bg-cyan-500/10">
          <span className="text-cyan-400 text-sm font-medium">
            Lead Generation 2.0
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight landing-gradient-text">
          B2B Lead Generation
          <br />
          Made Easy
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl landing-text-muted max-w-2xl mx-auto mb-10">
          Discover qualified leads with AI-powered insights. Enrich data automatically 
          and close more deals faster than ever before.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/auth" className="landing-btn-primary flex items-center gap-2">
            Get Started
            <ArrowRight className="w-4 h-4" />
          </Link>
          <a href="#how-it-works" className="landing-btn-outline">
            Learn More
          </a>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-32 left-10 w-4 h-4 border border-purple-500/50 rotate-45 hidden lg:block" />
        <div className="absolute bottom-20 right-16 w-6 h-6 rounded-full border border-cyan-500/50 hidden lg:block" />
      </div>
    </section>
  );
};
